<template>
  <CommonTable
    ref="table"
    :data="tableData"
    :total="total"
    @change="handleTableChange"
    :operation="operation"
    @operation="handleOperation"
    :table-json="tablejson"
  >
  </CommonTable>
</template>

<script>
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'
export default {
  mixins: [formTableMixin],
  props: {
    roleList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tablejson,
      operation: [
        {
          name: '重置密码',
          type: 'reset',
          width: 100,
          hide: () => {
            return !this.resetRole
          }
        },
        {
          name: '禁用',
          type: 'disabled',
          hide: (row) => {
            return row.state == 'DISABLED' || !this.stateRole
          }
        },
        {
          name: '启用',
          type: 'enable',
          hide: (row) => {
            return row.state == 'ENABLE' || !this.stateRole
          }
        }
      ],
      queryApi: this.$api.channel.account_customer_list
    }
  },
  computed: {
    resetRole() {
      let role = getRoleByOperationCode(this.roleList, 'reset')
      return role ? role.isPermission == 'Y' : false
    },
    stateRole() {
      let val = getRoleByOperationCode(this.roleList, 'state')
      return val ? val.isPermission == 'Y' : false
    }
  },
  watch: {
    productKey() {
      this.formSearch()
    }
  },
  methods: {
    formSearch(data) {
      const params = {
        ...data,
        child: true,
        [this.type + 'Id']: this.$route.query.id
      }
      this.search(params, null, this.queryApi)
    },
    handleReset(row) {
      this.row = row
      this.historyVisible = true
    },
    async handleSetState(row, state) {
      let tip = state == 'ENABLE' ? '启用' : '禁用'
      let params = {
        id: row.id,
        state
      }
      this.$ajax
        .post(this.$api.system.account_state_change, params)
        .then(() => {
          this.$message.success(`${tip} 成功`)
          this.formSearch(this.cacheData, this.cachePage)
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'reset':
          this.handleReset(row)
          break
        case 'disabled':
          this.handleSetState(row, 'DISABLED')
          break
        case 'enable':
          this.handleSetState(row, 'ENABLE')
          break
      }
    }
  }
}
</script>
